export { default } from './DeliveryAddressModal'



// WEBPACK FOOTER //
// ./src/App/components/DeliveryAddressModal/index.js